// extracted by mini-css-extract-plugin
module.exports = {"error":"error_error__v2Ayg","active":"error_active__U4JUL"};